module.exports = __webpack_public_path__ + "img/rivendell-3018-10-18.e7871a9e.jpg";